import * as core from '../../../../../../../core'

import { query } from './delete-term.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.delete-term',
    description: 'Delete Term',
    name: 'Delete Term',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
